import type { ReactNode } from "react";

import { Icon, type IconName } from "./Icon";
import "./EmptyState.css";

type Props = {
  icon?: IconName;
  title: string;
  description?: string;
  action?: ReactNode;
  size?: "sm" | "md" | "lg";
};

export function EmptyState({ icon = "search", title, description, action, size = "md" }: Props) {
  return (
    <div className={`empty-state empty-${size}`}>
      <div className="empty-icon">
        <Icon name={icon} size={size === "lg" ? 28 : size === "sm" ? 18 : 22} />
      </div>
      <h3 className="empty-title">{title}</h3>
      {description && <p className="empty-desc">{description}</p>}
      {action && <div className="empty-action">{action}</div>}
    </div>
  );
}
